import { SEND_EMAIL_REQUEST } from '../../constants/actions/policy';

export function sendEmailRequest(payload) {
    return {
        type: SEND_EMAIL_REQUEST,
        payload,
    };
}
